import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearFilter } from "../redux/filters/actions";
import Blog from "./Blog";

const BlogList = () => {
    const { blogs, filters } = useSelector((state) => state);
    const { category, author, input } = filters;
    const dispatch = useDispatch();

    const handleClearFilter = () => {
        dispatch(clearFilter());
    };

    const handleFilterByCategory = (blog) => {
        if (category === "") {
            return true;
        }
        return blog?.category === category;
    };

    const handleFilterByAuthor = (blog) => {
        if (author === "") {
            return true;
        }
        return blog?.authorName === author;
    };

    const handleFilterBySearch = (blog) => {
        const blogTitle = blog.title;

        if (input === "") {
            return true;
        }

        return blogTitle.toLowerCase().includes(input);
    };

    return (
        <section className="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-16 lg:pb-16 lg:px-8">
            <div className="absolute inset-0">
                <div className="bg-white h-1/3 sm:h-2/3"></div>
            </div>
            <div className="relative max-w-7xl mx-auto">
                <div className="text-center">
                    <h2 className="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl">
                        ALL BLOGS ARE HERE
                    </h2>
                    <p className="mt-3 max-w-2xl mx-auto text-xl text-gray-500 sm:mt-4">
                        Lorem ipsum dolor sit amet consectetur, adipisicing
                        elit. Ipsa libero labore natus atque, ducimus sed.
                    </p>
                </div>

                {category !== "" || author !== "" || input !== "" ? (
                    <div className="mt-6 -mb-5 flex items-center justify-between">
                        <p className="text-base text-gray-500">
                            Showing result's for :{" "}
                            <span className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800">
                                {input || category || author}
                            </span>
                        </p>
                        {!input.length > 0 && (
                            <button
                                className="flex items-center gap-2 rounded-full text-sm font-medium bg-red-100 text-red-800 px-4 py-2"
                                type="button"
                                onClick={handleClearFilter}
                            >
                                <span>Clear filter</span>
                                <span className="material-symbols-outlined">
                                    tune
                                </span>
                            </button>
                        )}
                    </div>
                ) : null}

                {/* BlogList here */}
                {blogs.filter(handleFilterBySearch).length === 0 ? (
                    <div className="text-center text-red-500 text-xl font-medium mt-20">
                        Sorry! no blogs found.
                    </div>
                ) : (
                    <div className="mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none">
                        {blogs
                            .filter(handleFilterBySearch)
                            .filter(handleFilterByCategory)
                            .filter(handleFilterByAuthor)
                            .map((blog) => (
                                <Blog blog={blog} key={blog.id} />
                            ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default BlogList;
